import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule, APP_INITIALIZER } from "@angular/core";
import { NgOtpInputModule } from "ng-otp-input";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ActivatedRouteSnapshot, RouterModule } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgCircleProgressModule } from "ng-circle-progress";
// import { AngularFontAwesomeModule } from "angular-font-awesome";
import { NgxSpinnerModule } from "ngx-spinner";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { ForgotPassComponent } from "./authentication/forgot-pass/forgot-pass.component";
import { HomeComponent } from "./authentication/home/home.component";
import { InfoBasicComponent } from "./authentication/info-basic/info-basic.component";
import { LoginComponent } from "./authentication/login/login.component";
import { PlansComponent } from "./authentication/plans/plans.component";
import { RegisterComponent } from "./authentication/register/register.component";
import { SetNewPassComponent } from "./authentication/set-new-pass/set-new-pass.component";
import { UsrActAckComponent } from "./authentication/usr-act-ack/usr-act-ack.component";
import { AuthGuard } from "./authguard/auth.guard";
import { RoleGuard } from "./authguard/role-guard";
import { FooterComponent } from "./common-component/footer/footer.component";
import { HeaderComponent } from "./common-component/header/header.component";
import { NavbarComponent } from "./common-component/navbar/navbar.component";
import { SearchComponentComponent } from "./common-component/search-component/search-component.component";
import { SidebarComponent } from "./common-component/sidebar/sidebar.component";
import { AdmindashboardComponent } from "./component/admindashboard/admindashboard.component";
import { AppointmentsSidebarComponent } from "./component/appointments-sidebar/appointments-sidebar.component";
import { CheckinComponent } from "./component/checkin/checkin.component";
import { CheckoutComponent } from "./component/checkout/checkout.component";
import { componentComponent } from "./component/component.component";
import { ContactComponent } from "./component/contact/contact.component";
import { DashboardComponent } from "./component/dashboard/dashboard.component";
import { DeleteDoctorProfileComponent } from "./component/delete-doctor-profile/delete-doctor-profile.component";
import { DeleteFdeskProfileComponent } from "./component/delete-fdesk-profile/delete-fdesk-profile.component";
import { DoctorEditProfileComponent } from "./component/doctor-edit-profile/doctor-edit-profile.component";
import { DoctorProfileComponent } from "./component/doctor-profile/doctor-profile.component";
import { DragDropComponent } from "./component/drag-drop/drag-drop.component";
import { EditFdeskProfileComponent } from "./component/edit-fdesk-profile/edit-fdesk-profile.component";
import { EditableComponent } from "./component/editable/editable.component";
import { EditprescComponent } from "./component/editpresc/editpresc.component";
import { ExpandRegisterComponent } from "./component/expand-register/expand-register.component";
import { FdeskProfileComponent } from "./component/fdesk-profile/fdesk-profile.component";
import { FrontDeskComponent } from "./component/front-desk/front-desk.component";
import { HelpComponent } from "./component/help/help.component";
import { MessagesComponent } from "./component/messages/messages.component";
import { PageNotFoundComponent } from "./component/page-not-found/page-not-found.component";
import { PatientDeleteProfileComponent } from "./component/patient-delete-profile/patient-delete-profile.component";
import { PatientDetailsComponent } from "./component/patient-details/patient-details.component";
import { PatientEditProfileComponent } from "./component/patient-edit-profile/patient-edit-profile.component";
import { PatientListComponent } from "./component/patient-list/patient-list.component";
import { PatientProfileComponent } from "./component/patient-profile/patient-profile.component";
import { PatientComponent } from "./component/patient/patient.component";
import { PhydashComponent } from "./component/phydash/phydash.component";
import { PrescriptionComponent } from "./component/prescription/prescription.component";
import { ProfilesComponent } from "./component/profiles/profiles.component";
import { SearchUserComponent } from "./component/search-user/search-user.component";
import { UpdateLabComponent } from "./component/update-lab/update-lab.component";
import { DndDirective } from "./directives/dnd.directive";
import { EditModeDirective } from "./directives/edit-mode.directive";
import { LoaderDirective } from "./directives/loader.directive";
import { ViewModeDirective } from "./directives/view-mode.directive";
import { SdFormFieldTextboxComponent } from "./forms/sd-form-field-textbox/sd-form-field-textbox.component";
import { SdFormFieldComponent } from "./forms/sd-form-field/sd-form-field.component";
import { TokenInterceptorService } from "./interceptor/token-interceptor.service";
import { FilterPipe } from "./pipe/filter.pipe";
import { PatientFilter } from "./pipe/patientFilter.pipe";
import { PhysicianFilter } from "./pipe/physicianFilter";
import { SdFormFieldDateComponent } from "./forms/sd-form-field-date/sd-form-field-date.component";
import { SdFormFieldDropdownComponent } from "./forms/sd-form-field-dropdown/sd-form-field-dropdown.component";
import { SdFormFieldRadioComponent } from "./forms/sd-form-field-radio/sd-form-field-radio.component";
import { SdFormFieldTextareaComponent } from "./forms/sd-form-field-textarea/sd-form-field-textarea.component";
import { NgbDateParserFormatter } from "@ng-bootstrap/ng-bootstrap";
import { NgbDateCustomParserFormatter } from "./models/NgbDateCustomParserFormatter";
import { OrganisationEditComponent } from "./component/organisation-edit/organisation-edit.component";
import { OrgsrvComponent } from "./component/orgsrv/orgsrv.component";
import { DoctorCalendarComponent } from "./component/doctor-calendar/doctor-calendar.component";
import { CalendarModule, DateAdapter } from "angular-calendar";
import { adapterFactory } from "angular-calendar/date-adapters/date-fns";
import { CommonModule } from "@angular/common";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { OnlineDoctorAppointmentComponent } from "./component/online-doctor-appointment/online-doctor-appointment.component";
import { AppointmentRequestComponent } from "./component/appointment-request/appointment-request.component";
import { ShareButtonsModule } from "ngx-sharebuttons/buttons";
import { InvoiceComponent } from "./component/invoice/invoice.component";
import { DoctorConsultationComponent } from "./component/doctor-consultation/doctor-consultation.component";
import { CameraComponent } from "./component/vedio-components/camera/camera.component";
import { ParticipantsComponent } from "./component/vedio-components/participants/participants.component";
import { RoomsComponent } from "./component/vedio-components/rooms/rooms.component";
import { SettingsComponent } from "./component/vedio-components/settings/settings.component";
import { DeviceSelectComponent } from "./component/vedio-components/settings/device-select.component";
import { VedioHomeComponent } from "./component/vedio-components/home/home.component";
import { ViewConsultationAppointmentComponent } from "./component/view-consultation-appointment/view-consultation-appointment.component";
import { ConsultationSummaryComponent } from "./component/consultation-summary/consultation-summary.component";
import { HeaderNewComponent } from "./common-component/header-new/header-new.component";
import { FooterNewComponent } from "./common-component/footer-new/footer-new.component";
import { FeedbackComponent } from "./component/feedback/feedback.component";
import { ViewAppointmentPatientComponent } from "./component/view-appointment-patient/view-appointment-patient.component";
import { AppointmentSearchComponent } from "./component/appointment-search/appointment-search.component";
import { DoctorSearchComponent } from "./component/doctor-search/doctor-search.component";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatNativeDateModule } from "@angular/material/core";
import { MAT_DATE_LOCALE } from "@angular/material/core";
import { MatInputModule } from "@angular/material/input";
import { PhysicianTransactionComponent } from "./component/physician-transaction/physician-transaction.component";
import { LoginNewComponent } from "./component/login-new/login-new.component";
import { ForgotPassNewComponent } from "./component/forgot-pass-new/forgot-pass-new.component";
import { ResetPassNewComponent } from "./component/reset-pass-new/reset-pass-new.component";
import { CreateAccountComponent } from "./component/create-account/create-account.component";
import { PatientMembersComponent } from "./component/patient-members/patient-members.component";
import { AppointmentsPastComponent } from "./component/appointments-past/appointments-past.component";
import { AppointmentsPatientComponent } from "./component/appointments-patient/appointments-patient.component";
import { PatientAccountComponent } from "./component/patient-account/patient-account.component";
import { PatientAddComponent } from "./component/patient-add/patient-add.component";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { SuperadminPhysiciansComponent } from "./component/superadmin-physicians/superadmin-physicians.component";
import { SpecialitiesComponent } from "./component/specialities/specialities.component";
import { DefaultPayoutComponent } from "./component/default-payout/default-payout.component";
import { SuperadminPhyDetailComponent } from "./component/superadmin-phy-detail/superadmin-phy-detail.component";
import { SuperadminPatientsComponent } from "./component/superadmin-patients/superadmin-patients.component";
import { SuperadminPatDetailComponent } from "./component/superadmin-pat-detail/superadmin-pat-detail.component";
import { CouponsGenerateComponent } from "./component/coupons-generate/coupons-generate.component";
import { CouponsSearchComponent } from "./component/coupons-search/coupons-search.component";
import { ExcelService } from "./service/excelDownload/excel.service";
import { CouponsEditComponent } from "./component/coupons-edit/coupons-edit.component";
import { PatientChatComponent } from "./component/patient-chat/patient-chat.component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { SuperadminAppointmentComponent } from "./component/superadmin-appointment/superadmin-appointment.component";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { ConnectionService } from "./service/connection/connection.service";
import { SocketsConnectionService } from "./service/websockets/connection.service";
import { RealTimeService } from "./service/websockets/realtime.service";
import { MyfilesComponent } from './component/myfiles/myfiles.component';
import { PhysicianPayloadComponent } from './component/physician-payload/physician-payload.component';
import { AdhocApptComponent } from './component/adhoc-appt/adhoc-appt.component';
import { AdhocNewapptComponent } from './component/adhoc-newappt/adhoc-newappt.component';
import { PatientHelathStatsUpdateComponent } from './component/patient-helath-stats-update/patient-helath-stats-update.component';
import { PatientrecsearchComponent } from './component/patientrecsearch/patientrecsearch.component';
import { SuperadminMedicineCreateComponent } from './component/superadmin-medicine-create/superadmin-medicine-create.component';
import { SuperadminMedicineSearchComponent } from './component/superadmin-medicine-search/superadmin-medicine-search.component';
import { SuperadminAddcategoryComponent } from './component/superadmin-addcategory/superadmin-addcategory.component';
import { SuperadminAddsubcategoryComponent } from './component/superadmin-addsubcategory/superadmin-addsubcategory.component';
import { PrescTempCreateComponent } from './component/presc-temp-create/presc-temp-create.component';
import { PrescTempEditComponent } from './component/presc-temp-edit/presc-temp-edit.component';
import { CheckoutDashComponent } from './component/checkout-dash/checkout-dash.component';
import { CheckinDashComponent } from './component/checkin-dash/checkin-dash.component';
import { AptreqDashComponent } from './component/aptreq-dash/aptreq-dash.component';
import { ProfilesDashComponent } from './component/profiles-dash/profiles-dash.component';
import { SuperadminPhysicianPayoutComponent } from './component/superadmin-physician-payout/superadmin-physician-payout.component';
import { PatientOrganisationComponent } from './component/patient-organisation/patient-organisation.component';
import { SearchUserDirective } from './component/search-user/search-user.directive';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { SuperadminIllnessListComponent } from './component/superadmin-illness-list/superadmin-illness-list.component';
import { SuperadminLabtestComponent } from './component/superadmin-labtest/superadmin-labtest.component';
import { AvatarComponent } from "./component/search-user/avatar.component";
import { CacheService } from './common/cacheRemove';
import { DocdashboardComponent } from './component/docdashboard/docdashboard.component';
import { AddashboardComponent } from './component/addashboard/addashboard.component';
export function clearIndexHtmlCache(cacheService: CacheService) {
  return () => cacheService.clearCacheForFile('index.html');
}
@NgModule({
  declarations: [
    AvatarComponent,
    AppComponent,
    LoginComponent,
    RegisterComponent,
    PatientComponent,
    PrescriptionComponent,
    HomeComponent,
    PrescriptionComponent,
    InfoBasicComponent,
    PlansComponent,
    PatientDetailsComponent,
    DashboardComponent,
    ExpandRegisterComponent,
    PatientFilter,
    PhysicianFilter,
    FilterPipe,
    FrontDeskComponent,
    PageNotFoundComponent,
    AppointmentsSidebarComponent,
    ProfilesComponent,
    MessagesComponent,
    HelpComponent,
    ContactComponent,
    PatientProfileComponent,
    DoctorProfileComponent,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    SearchComponentComponent,
    componentComponent,
    NavbarComponent,
    CheckinComponent,
    CheckoutComponent,
    UsrActAckComponent,
    PhydashComponent,
    ForgotPassComponent,
    SetNewPassComponent,
    PatientListComponent,
    EditprescComponent,
    UpdateLabComponent,
    AdmindashboardComponent,
    FdeskProfileComponent,
    LoaderDirective,
    PatientEditProfileComponent,
    PatientDeleteProfileComponent,
    DoctorEditProfileComponent,
    DeleteDoctorProfileComponent,
    EditFdeskProfileComponent,
    DeleteFdeskProfileComponent,
    SearchUserComponent,
    EditModeDirective,
    ViewModeDirective,
    EditableComponent,
    DndDirective,
    DragDropComponent,
    SdFormFieldTextboxComponent,
    SdFormFieldComponent,
    SdFormFieldDateComponent,
    SdFormFieldDropdownComponent,
    SdFormFieldRadioComponent,
    SdFormFieldTextareaComponent,
    OrganisationEditComponent,
    OrgsrvComponent,
    DoctorCalendarComponent,
    OnlineDoctorAppointmentComponent,
    AppointmentRequestComponent,
    InvoiceComponent,
    DoctorConsultationComponent,
    CameraComponent,
    ParticipantsComponent,
    RoomsComponent,
    SettingsComponent,
    DeviceSelectComponent,
    VedioHomeComponent,
    ViewConsultationAppointmentComponent,
    ConsultationSummaryComponent,
    HeaderNewComponent,
    FooterNewComponent,
    FeedbackComponent,
    ViewAppointmentPatientComponent,
    AppointmentSearchComponent,
    DoctorSearchComponent,
    PhysicianTransactionComponent,
    LoginNewComponent,
    ForgotPassNewComponent,
    ResetPassNewComponent,
    CreateAccountComponent,
    PatientMembersComponent,
    AppointmentsPastComponent,
    AppointmentsPatientComponent,
    PatientAccountComponent,
    PatientAddComponent,
    SuperadminPhysiciansComponent,
    SpecialitiesComponent,
    DefaultPayoutComponent,
    SuperadminPhyDetailComponent,
    SuperadminPatientsComponent,
    SuperadminPatDetailComponent,
    CouponsGenerateComponent,
    CouponsSearchComponent,
    CouponsEditComponent,
    PatientChatComponent,
    SuperadminAppointmentComponent,
    MyfilesComponent,
    PhysicianPayloadComponent,
    AdhocApptComponent,
    AdhocNewapptComponent,
    PatientHelathStatsUpdateComponent,
    PatientrecsearchComponent,
    SuperadminMedicineCreateComponent,
    SuperadminMedicineSearchComponent,
    SuperadminAddcategoryComponent,
    SuperadminAddsubcategoryComponent,
    PrescTempCreateComponent,
    PrescTempEditComponent,
    CheckoutDashComponent,
    CheckinDashComponent,
    AptreqDashComponent,
    ProfilesDashComponent,
    SuperadminPhysicianPayoutComponent,
    PatientOrganisationComponent,
    SearchUserDirective,
    SuperadminIllnessListComponent,
    SuperadminLabtestComponent,
    DocdashboardComponent,
    AddashboardComponent,

  ],
  imports: [
    AngularMultiSelectModule,
    CommonModule,
    FontAwesomeModule,
    DragDropModule,
    BrowserModule,
    PdfViewerModule,
    NgOtpInputModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NgCircleProgressModule.forRoot(),
    // AngularFontAwesomeModule,
    HttpClientModule,
    RouterModule,
    NgbModule,
    NgxSpinnerModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    InfiniteScrollModule,
    ShareButtonsModule.withConfig({
      debug: true,
    }),
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatInputModule,
  ],
  providers: [
    RouterModule,
    ReactiveFormsModule,
    AuthGuard,
    SocketsConnectionService,
    RealTimeService,
    ConnectionService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true,
    },
    RoleGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true,
    },
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter },
    { provide: MAT_DATE_LOCALE, useValue: "en-GB" },
    ExcelService,
    CacheService,
    {
      provide: APP_INITIALIZER,
      useFactory: clearIndexHtmlCache, //<--- calling function on Angular App init
      deps: [CacheService], //<---- Important deps
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
